export const BULK_USER_ADD_INIT_ACTION = "BULK_USER_ADD_INIT_ACTION";
export const BULK_USER_ADD_SUCCESS_ACTION = BULK_USER_ADD_INIT_ACTION + "_SUCCESS";
export const BULK_USER_ADD_FAIL_ACTION = BULK_USER_ADD_INIT_ACTION + "_ERROR";

export const CLEAR_BULK_USER_ADD_INIT_ACTION = 'CLEAR_BULK_USER_ADD_INIT_ACTION';

export const FETCH_PINCODE_DETAILS_INIT_ACTION = "FETCH_PINCODE_DETAILS_INIT_ACTION";
export const FETCH_PINCODE_DETAILS_SUCCESS_ACTION = FETCH_PINCODE_DETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_PINCODE_DETAILS_FAIL_ACTION = FETCH_PINCODE_DETAILS_INIT_ACTION + "_ERROR";
